import { render, staticRenderFns } from "./deliverDetails.vue?vue&type=template&id=2fa62d9f&scoped=true&"
import script from "./deliverDetails.vue?vue&type=script&lang=js&"
export * from "./deliverDetails.vue?vue&type=script&lang=js&"
import style0 from "./deliverDetails.vue?vue&type=style&index=0&id=2fa62d9f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fa62d9f",
  null
  
)

export default component.exports